import * as React from 'react';
import * as Constants from '../consts/variables';
import { __ } from '../helpers/TranslationService';
import { Discount } from './Discount';
import { Link } from './Link';
import { PriceString } from './PriceString';

export interface ITeaser {
    link?: string;
    price?: number;
    imageUrl: string;
    title?: string;
    text?: string;
    currency?: string;
    discount?: number;
    followLink?: boolean;
}

const figureStyle: React.CSSProperties = {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
};
const imgStyle: React.CSSProperties = {
    width: '100%',
    minHeight: 120,
    display: 'block',
};
const teaserTextStyle: React.CSSProperties = {
    color: Constants.blue,
    fontSize: '14px',
    marginTop: '7px',
    textAlign: 'center',
    display: 'block',
};
const priceStyle: React.CSSProperties = {
    position: 'absolute',
    right: '0px',
    bottom: '10px',
    fontSize: '22px',
    background: 'rgba(255, 255, 255, 0.66)',
    textAlign: 'center',
    padding: '5px 0 5px 5px',
    fontWeight: 'bold',
};
const teaserTitleStyle: React.CSSProperties = {
    position: 'absolute',
    fontSize: '30px',
    color: 'white',
    textAlign: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    margin: '0px',
    paddingRight: '10px',
    paddingLeft: '10px',
    textShadow: 'rgba(0, 0, 0, 0.90) 0px 0px 6px',
};

const discountWrapper: React.CSSProperties = {
    marginRight: 0,
    marginLeft: '15px',
    flex: '0 0 auto',
    transform: 'rotate(180deg)',
};

const discountInner: React.CSSProperties = {
    fontSize: 11,
    padding: '5px 5px',
    transform: 'rotate(180deg)',
};

const innerFlexBox: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
};

const innerFromSpan: React.CSSProperties = {
    fontWeight: 'normal',
    fontSize: 14,
    flex: '1 0 auto',
    textAlign: 'right',
};

const priceTag: React.CSSProperties = {
    padding: '5px 15px 0px 15px',
};

const teaserLink: React.CSSProperties = {
    display: 'block',
};
export function Teaser(props: ITeaser) {
    const { link, followLink, imageUrl, text, title, discount, price, currency } = props;
    const priceProps = { price, currency };
    const priceColor = {
        color: discount > 0 ? Constants.pink : Constants.black,
    };
    const getPrice = () =>
        price > 0 ? <PriceString {...priceProps} /> : __('on request', 'dreamlines');
    return (
        <Link href={link} followLink={followLink} style={teaserLink}>
            <figure style={figureStyle}>
                {title && <h4 style={teaserTitleStyle}>{title} </h4>}
                {(price || discount > 0) && (
                    <div style={{ ...priceStyle, ...priceColor }}>
                        {discount > 0 && (
                            <div style={innerFlexBox}>
                                <span style={innerFromSpan}>
                                    {price > 0 && __('from', 'dreamlines')}
                                </span>
                                <Discount
                                    discount={discount}
                                    wrapperStyle={discountWrapper}
                                    innerStyle={discountInner}
                                    type="ribbon"
                                />
                            </div>
                        )}
                        {price && <div style={priceTag}> {getPrice()}</div>}
                    </div>
                )}
                <img src={imageUrl} style={imgStyle} alt={title} loading="lazy" />
            </figure>
            <span style={teaserTextStyle}>{text} </span>
        </Link>
    );
}
